import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import {
  EditorTemplateState,
  STORE_FEATURE_KEY_EDITOR_TEMPLATE,
} from "./editor.reducer";
import { ContentAndModelId } from "../types/editor-types";

const getEditorTemplateState = (state: any) =>
  state[STORE_FEATURE_KEY_EDITOR_TEMPLATE];

@Injectable()
export class EditorSelectors {
  constructor(private store: Store<any>) {}

  selectEditorTemplateState(): Observable<EditorTemplateState> {
    return this.store.pipe(select(getEditorTemplateState));
  }

  getPresent(): Observable<ContentAndModelId> {
    return this.selectEditorTemplateState().pipe(
      select((state) => state.present)
    );
  }

  canUndo(): Observable<boolean> {
    return this.selectEditorTemplateState().pipe(
      select((state) => state.past.length > 0)
    );
  }

  canRedo(): Observable<boolean> {
    return this.selectEditorTemplateState().pipe(
      select((state) => state.future.length > 0)
    );
  }

  getWindowSelectionTimestamp(): Observable<number> {
    return this.selectEditorTemplateState().pipe(
      select((state) => state.windowSelectionTimestamp)
    );
  }
}
